<mat-card>
  <div class="row">
    <div class="col-md-10">
<h2>RESTAURANTS</h2></div>
<div class="col-md-2">
</div></div>
<div class="row">
  <div class="col-md-8">

  <mat-form-field class="search">
    <mat-label>Search</mat-label>
    <input (keyup)="applyFilter($event.target.value)" matInput placeholder="Search"   >
    </mat-form-field>
</div>

<div class="col-md-4 text-center">
  <button mat-button (click)="addRestaurant()" class="add">Add New </button>
  </div>
</div>
<table mat-table [dataSource]="memberss" matSort>
    <!-- <ng-container matColumnDef="image">
<th mat-header-cell *matHeaderCellDef mat-sort-header>Image </th>
<td mat-cell *matCellDef="let member" role="gridcell"> </td>
</ng-container> -->

<ng-container matColumnDef="image">
  <th mat-header-cell *matHeaderCellDef mat-sort-header>IMAGE</th>
  <td mat-cell *matCellDef="let member" role="gridcell"> <img class="mei"src="{{member.image.url}}"> </td>
  </ng-container>
  <ng-container matColumnDef="name">
<th mat-header-cell *matHeaderCellDef mat-sort-header>NAME</th>
<td mat-cell *matCellDef="let member" role="gridcell"> <p id="name">{{member.name}}</p> </td>
</ng-container>
  <!-- <ng-container matColumnDef="food">
<th mat-header-cell *matHeaderCellDef mat-sort-header>Food</th>
<td mat-cell *matCellDef="let member" role="gridcell">{{member.categories.name}} </td>
</ng-container>
  <ng-container matColumnDef="referals">
<th mat-header-cell *matHeaderCellDef mat-sort-header>Promo</th>
<td mat-cell *matCellDef="let member" role="gridcell">{{member.promo}} </td>
</ng-container> -->
<ng-container matColumnDef="price">
  <th mat-header-cell *matHeaderCellDef mat-sort-header>Price FOR 2</th>
  <td mat-cell *matCellDef="let member" role="gridcell">{{member.price}}</td>
  </ng-container>
  <ng-container matColumnDef="email" >
<th mat-header-cell *matHeaderCellDef mat-sort-header >EMAIL</th>
<td mat-cell *matCellDef="let member" role="gridcell"> {{member.email}} </td>
</ng-container>
<ng-container matColumnDef="phone" >
    <th mat-header-cell *matHeaderCellDef mat-sort-header >CONTACT</th>
    <td mat-cell *matCellDef="let member" role="gridcell"> {{member.phone}} </td>
    </ng-container>
    <ng-container matColumnDef="address" >
        <th mat-header-cell *matHeaderCellDef mat-sort-header >ADDRESS</th>
        <td mat-cell *matCellDef="let member" role="gridcell"> {{member.address}} </td>
        </ng-container>
        <ng-container matColumnDef="rating" >
            <th mat-header-cell *matHeaderCellDef mat-sort-header >Rating</th>
            <td mat-cell *matCellDef="let member" role="gridcell">4<mat-icon>star</mat-icon> </td>
            </ng-container>
            <ng-container matColumnDef="status" >
              <th mat-header-cell *matHeaderCellDef mat-sort-header >STATUS</th>
              <td mat-cell *matCellDef="let member" role="gridcell">{{member.status}}</td>
              </ng-container>
<ng-container matColumnDef="action"  >
<th mat-header-cell *matHeaderCellDef>ACTION</th>
<td mat-cell *matCellDef="let member" role="gridcell"><div *ngIf="member.id!='5eb945784819db09e88ad847'">
<a class="edit" (click)="edit(member.id)"><mat-icon>edit</mat-icon></a>
<button class="dlt" (click)="deleteRestaurant(member.id,member.image)"><mat-icon>delete</mat-icon></button></div>

</td>

</ng-container>
<!--in row which column will display is assigned in displayedColumns-->
<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row  (click)="logData(row)" *matRowDef="let row; columns: displayedColumns;"></tr>
			 </table>
<mat-paginator [length]="15" [pageSize]="5" [pageSizeOptions]="[5,10,15]" showFirstLastButtons></mat-paginator></mat-card>